module.exports = __webpack_public_path__ + "images/kihnu/og-image.png";